// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"c5141b6f","513":"1b785e4b","703":"afa01073","787":"39102bee"}[chunkId] + ".chunk.js";
};